export const SET_CHARACTER_MASTER_DATA = 'SET_CHARACTER_MASTER_DATA';
export const setCharacterMasterData = (characterData) => ({
    type: SET_CHARACTER_MASTER_DATA,
    payload: characterData
});
